import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { useDispatch } from 'react-redux';

export const useDisableGoogle2FAQuery = () => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	return useMutationHook(
		[endPointUrls.GENERATE2FA_DISABLE],
		(data) => api.post(endPointUrls.GENERATE2FA_DISABLE, data),
		{
			onSuccess: (res: any) => {
				if (res?.status === 200) {
					queryClient.invalidateQueries([endPointUrls.PROFILE_MANAGEMENT]);
					toastHandler('success', res?.data.message);
					dispatch(setApiCatcherFormErrors([]));

					api.post('/reset2fa', {});
				}
			},
		}
	) as UseMutationResult;
};
